/*************************************************/
/* Vue                                           */
/*************************************************/
import { createApp, h } from 'vue';
import PrimeVue from 'primevue/config';
import PrimevueLocale from './vue/primevueLocale';
import MiniLoanCalculator from './vue/miniLoanCalculator';

const modelElement = document.querySelector('#vehicleModel');

const miniLoanCalculatorSelector = '#miniLoanCalculatorApp';
const orderVehicleFlowElement = document.querySelector(miniLoanCalculatorSelector);
if (orderVehicleFlowElement) {
    const vehicle = modelElement.dataset.vehicle;

    const seedData = {
        vehicle: vehicle,
    };

    const miniLoanCalculator = createApp({
        data() { return seedData },
        render: () => h(MiniLoanCalculator)
    }, seedData);

    miniLoanCalculator.use(PrimeVue, {
        locale: PrimevueLocale.locale
    });

    miniLoanCalculator.mount(miniLoanCalculatorSelector);
}